import { ShortlinkService } from ".."

class FeedbackService {
    updateFeedBack = async ({ status, link }: { status: boolean; link: string }): Promise<void> => {
        return await ShortlinkService.put(`/v1/link/${link}`, { feedback: status })
    }
}

export default new FeedbackService()
